import React, { useState } from 'react';

const ProjectList = ({ 
  projects, 
  selectedProject, 
  onSelectProject, 
  onAddProject, 
  onUpdateProject, 
  onDeleteProject 
}) => {
  const [showAddForm, setShowAddForm] = useState(false);
  const [editingProject, setEditingProject] = useState(null);
  const [newProjectName, setNewProjectName] = useState('');
  const [newProjectColor, setNewProjectColor] = useState('#97feed');

  const handleAddProject = (e) => {
    e.preventDefault();
    if (newProjectName.trim()) {
      onAddProject({
        name: newProjectName.trim(),
        color: newProjectColor
      });
      setNewProjectName('');
      setNewProjectColor('#97feed');
      setShowAddForm(false);
    }
  };

  const handleEditProject = (project) => {
    setEditingProject(project);
    setNewProjectName(project.name);
    setNewProjectColor(project.color);
  };

  const handleUpdateProject = (e) => {
    e.preventDefault();
    if (newProjectName.trim()) {
      onUpdateProject({
        ...editingProject,
        name: newProjectName.trim(),
        color: newProjectColor
      });
      setEditingProject(null);
      setNewProjectName('');
      setShowAddForm(false);
    }
  };

  const handleCancel = () => {
    setShowAddForm(false);
    setEditingProject(null);
    setNewProjectName('');
    setNewProjectColor('#97feed');
  };

  return (
    <div className="project-list">
      <div className="project-header">
        <h3>Projects</h3>
        <button 
          className="add-project-btn"
          onClick={() => setShowAddForm(true)}
        >
          + Add Project
        </button>
      </div>
      
      <div className="project-items">
        {projects.map(project => (
          <div 
            key={project.id}
            className={`project-item ${selectedProject?.id === project.id ? 'selected' : ''}`}
            onClick={() => onSelectProject(project)}
          >
            <div 
              className="project-color"
              style={{ backgroundColor: project.color }}
            ></div>
            <span className="project-name">{project.name}</span>
            <div className="project-actions">
              <button 
                className="edit-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  handleEditProject(project);
                }}
              >
                Edit
              </button>
              <button 
                className="delete-btn"
                onClick={(e) => {
                  e.stopPropagation();
                  if (window.confirm(`Delete project "${project.name}" and all its tasks?`)) {
                    onDeleteProject(project.id);
                  }
                }}
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
      
      {(showAddForm || editingProject) && (
        <div className="project-form">
          <form onSubmit={editingProject ? handleUpdateProject : handleAddProject}>
            <input
              type="text"
              value={newProjectName}
              onChange={(e) => setNewProjectName(e.target.value)}
              placeholder="Project name"
              className="project-name-input"
              autoFocus
            />
            <input
              type="color"
              value={newProjectColor}
              onChange={(e) => setNewProjectColor(e.target.value)}
              className="project-color-input"
            />
            <div className="form-actions">
              <button type="submit" className="save-btn">
                {editingProject ? 'Update' : 'Add'}
              </button>
              <button type="button" onClick={handleCancel} className="cancel-btn">
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default ProjectList;
